<template>
  <div class="internal-job" ref="internalJob">
    <div class="resume-apply-success-wrapper">
      <div class="stripe company-customized-color"></div>
      <div class="logo">
        <img :src="company.logo ? $DjangoBaseUrl(company.logo) : $DjangoStaticUrl(`images_en/default_company.jpg`)"/>
      </div>
      <div class="content">
        <p class="title">
          <span v-if="company.root_company.id===3738">{{ $t('jobDetail.StarbucksInternalJobMsg') }}</span>
          <span v-else>{{ $t('jobDetail.otherInternalJobMsg',{company_name:company.i18n_name}) }}</span>
        </p>
      </div>
      <div class="more-information">
        <p class="main-body">
          {{ $t('jobDetail.moreInfo') }}
        </p>
        <ul class="auto-height">
          <li>
            <router-link :to="`/recruiting/company/${jobListCompanyId}/branding`">
              {{ $t('jobDetail.viewOtherJobs') }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="content">
        <p class="main-body">
          {{ $t('jobDetail.or') }}
        </p>
        <p class="main-body">
          <span v-if="company.root_company.id !== 3738" v-html="$t('jobDetail.clickHereToApply',{companyName:company.i18n_name,companyId:company.id})"></span>
          <span v-else v-html="$t('jobDetail.clickHereToApplyStarbucks',{companyId:company.id})"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    company: {
      type: Object,
      default: null,
      required: true
    },
    rootCompanyId: {
      default: null,
      required: true
    },
    hasReferralShare: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    jobListCompanyId () {
      return this.hasReferralShare ? this.rootCompanyId : this.company.id
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.internal-job {
  background-color: #000000;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  .resume-apply-success-wrapper {
    width: 86%;
    padding-bottom: 80px;
    margin: 10% 7%;
    background-color: #fff;
    font-size: 16px;
    .content {
      .title {
        font-weight: normal;
        font-size:100%;
        // font-size: 28px;
        // font-weight: bold;
        text-align: center;
      }
    }
  }
  .stripe {
    height: 15px;
    background-color: #fc8434;
  }
  .logo {
    img {
      width: 150px;
      height: 150px;
      display: block;
      margin: 0px auto;
    }
  }
  .content,
  .more-information {
    margin: 10px 5%;
  }
  p {
    padding: 10px 0;
  }
  a {
    text-decoration: underline;
  }
  .more-information{
    .title {
      font-weight: bold;
      font-size: 18px;
    }
    a {
      line-height: 24px;
      padding-left: 10px;
      position: relative;
      display: inline-block;
    }
    a::before {
      content: "";
      display: inline-block;
      height: 5px;
      width: 5px;
      background-color: #000000;
      border-radius: 50%;
      position: absolute;
      top: 8px;
      left: 0;
    }
    ul {
      height: 96px;
    }
    .auto-height {
      height: auto;
    }
  }
  .main-body {
    line-height: 1.5em;
  }
}

@media only screen and (max-device-height: 660px) {
  .resume-apply-success-wrapper {
    padding-bottom: 30px;
    font-size: 14px;
    margin-top: 8%;
  }
  .content {
    .title {
      font-size: 24px;
    }
  }
  .more-information {
    .title {
      font-weight: bold;
      font-size: 16px;
    }
  }
  p {
    padding: 5px 0;
  }
}

@media only screen and (max-device-height: 600px) {
  .resume-apply-success-wrapper {
    padding-bottom: 20px;
    font-size: 12px;
    margin-top: 6%;
  }
  .content {
    .title {
      font-size: 20px;
    }
  }
  .more-information {
    .title {
      font-weight: bold;
      font-size: 14px;
    }
  }
  p {
    padding: 6px 0;
  }
}
</style>
